<template>
  <div>
    <div class="card">
      <div class="card-header">
        <div class="row">
          <div class="col-sm-7">
            <h5 class="card-title">{{ psaCategory }}</h5>
          </div>
          <div class="col-sm-5 pt-1">
            <div class="row text-right justify-content-end">
              <div class="col-sm-auto">
                <p-button type="default" @click="newPsa()" title="PSA hinzufügen" class="mt-0 mr-0" v-if="role > 1 && psaRole > 1"><i class="bi bi-plus-circle" style="font-size: 16px;"></i> Hinzufügen</p-button>
              </div>
              <div class="col-sm-auto pl-1" >
                <el-select v-model="psaCategory" placeholder="PSA-Kategorie wählen" @change="updatePsaCategory">
                  <el-option v-for="category in psaCategories" :value="category.psaCatName" :label="category.psaCatName" :key="category.key"></el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="row mb-4 pb-3 pt-2">
          <div class="col-sm-4">
            <el-statistic title="Einsatzbereit" :value=counterOK group-separator="." :precision="0"></el-statistic>
          </div>
          <div class="col-sm-4">
            <el-statistic title="Prüfung fällig" :value=counterMaintenance group-separator="." :precision="0"></el-statistic>
          </div>
          <div class="col-sm-4">
            <el-statistic title="Nicht einsatzbereit" :value=counterNOK group-separator="." :precision="0"></el-statistic>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <el-table 
            ref="psaTable"
            :data="
              psa.filter(
                (data) =>
                  !search ||
                  data.psaType.toLowerCase().includes(search.toLowerCase())
              )
            " header-row-class-name="text-primary" empty-text="Es konnte keine PSA gefunden werden."
              v-loading="loading"
              :default-sort = "{prop: 'psaSerialNumber', order: 'ascending'}"
              @row-click="showDetails">
              <el-table-column prop="psaSerialNumber" label="Serien-Nr." min-width="130" sortable></el-table-column>
              <el-table-column prop="psaOwnId" label="Eigene Nr." min-width="130" sortable></el-table-column>
              <el-table-column prop="psaManufacturer" label="Hersteller" min-width="120"></el-table-column>
              <el-table-column prop="psaItem" label="Artikel"></el-table-column>
              <el-table-column prop="psaStatus" label="Status" min-width="120"
                :filters="[{ text: 'Einsatzbereit', value: 'OK' }, { text: 'Prüfung fällig', value: 'maintenance' }, { text: 'Nicht einsatzbereit', value: 'NOK' }]"
                :filter-method="filterStatus"
                filter-placement="bottom-end"
                align="center"
                sortable>
                <template slot-scope="scope">
                  <el-tag
                    v-if="scope.row.psaStatus === 'OK'"
                    type="success"
                    disable-transitions>Einsatzbereit</el-tag>
                  <el-tag
                    v-if="scope.row.psaStatus === 'maintenance'"
                    type="warning"
                    disable-transitions>Prüfung fällig</el-tag>
                  <el-tag
                    v-if="scope.row.psaStatus === 'NOK'"
                    type="danger"
                    disable-transitions>Nicht einsatzbereit</el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="psaLastMaintenance" label="Letzte Prüfung" min-width="100"></el-table-column>
              <el-table-column prop="psaNextMaintenance" label="Nächste Prüfung" min-width="100"></el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>

    <modal :show.sync="showNewPsaModal" headerClasses="justify-content-center" data-backdrop="static">
      <h5 slot="header" class="title mb-0">PSA hinzufügen</h5>
      <div class="row">
        <div class="col">
          <label class="pt-1">Vorlage:</label>
          <el-select v-model="newPsaTemplate" placeholder="Ohne Vorlage" clearable @change="templateSelected">
            <el-option v-for="template in psaTemplates" :value=template.psaTemplateName :label=template.psaTemplateName :key=template.key></el-option>
          </el-select>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label class="pt-4">Bezeichnung</label>
          <el-input v-model="newPsaName"></el-input>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label class="pt-4">Serien-Nummer:</label>
          <el-input v-model="newPsaSerialNumer" prefix-icon="el-icon-key"></el-input>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label class="pt-4">Eigene Nummer:</label>
          <el-input v-model="newPsaOwnId" prefix-icon="el-icon-key"></el-input>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label class="pt-4">GAL-Link:</label>
          <el-input v-model="newPsaGalLink" prefix-icon="el-icon-key"></el-input>
        </div>
      </div>
      <div class="row">
        <div class="col-md">
          <label class="pt-4">Hersteller:</label>
          <el-select v-model="newPsaManufacturer" placeholder="Hersteller auswählen" clearable>
            <el-option v-for="manufacturer in manufacturers" :value=manufacturer :label=manufacturer :key=manufacturer></el-option>
          </el-select>
        </div>
        <div class="col-md">
          <label class="pt-4">Kategorie:</label>
          <el-select v-model="newPsaType" placeholder="Kategorie auswählen" clearable>
            <el-option v-for="cat in psaCategories" :value=cat.psaCatName :label=cat.psaCatName :key=cat.psaCatName></el-option>
          </el-select>
        </div>
      </div>
      <div class="row">
        <div class="col-md">
          <label class="pt-4">Herstellung:</label>
          <el-date-picker v-model="newPsaProdDate" type="month" placeholder="Herstellungsdatum" :picker-options="pickerOptions" :clearable="false" format="MMMM yyyy"></el-date-picker>
        </div>
        <div class="col-md">
          <label class="pt-4">Inbetriebnahme:</label>
          <el-date-picker v-model="newPsaFirstUse" type="month" placeholder="Inbetriebnahme" :picker-options="pickerOptions" :clearable="false" format="MMMM yyyy"></el-date-picker>
        </div>
      </div>
      

      <template slot="footer">
        <div class="left-side">
          <p-button type="default" link @click="showNewPsaModal=false">Abbrechen</p-button>
        </div>
        <div class="divider"></div>
        <div class="right-side">
          <p-button type="success" link @click="addPsa()" :disabled="newPsaName == '' || newPsaSerialNumer == '' || newPsaProdDate == '' || newPsaFirstUse == '' || newPsaManufacturer == '' || newPsaType == ''">Hinzufügen</p-button>
        </div>
      </template>
    </modal>
  </div>
</template>
<script>
import Vue from "vue";
import { db } from "../../../../firebaseDb";
import { Table, TableColumn, Input, Loading, Popover, Tag, Select, Option, Statistic, MessageBox } from "element-ui";
import { Modal } from "src/components/UIComponents";
import moment from "moment-timezone";
import router from "../../../../main";
import store from "../../../../store";
import SelectLocation from '/src/components/KET/Views/Components/KETSelectLocation.vue'
import locations from "../../../../locationStore";
import psaData from "../../../../../psa.json";
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Popover);
Vue.use(Loading);
Vue.use(Tag)
Vue.use(Statistic)

export default {
  components: {
    [Input.name]: Input,
    SelectLocation,
    Modal,
    [Select.name]: Select,
    [Option.name]: Option,
    MessageBox,
  },

  data() {
    return {
      loading: true,
      psa: [],
      counterOK: 0,
      counterNOK: 0,
      counterMaintenance: 0,
      search: "",
      showNewPsaModal: false,
      psaTemplates: [],
      newPsaTemplate: "",
      newPsaName: "",
      newPsaGalLink: "",
      newPsaType: "",
      newPsaManufacturer: "",
      newPsaSerialNumer: "",
      newPsaOwnId: "",
      newPsaFirstUse: "",
      newPsaProdDate: "",
      newPsaEOL: 10,
      psaCategories: [],
      psaCategory: "",
      role: store.getters.userrole,
      psaRole: store.getters.psaRole,
      location: store.getters.userlocation,
      pickerOptions: {
          disabledDate(time) {
            return time.getTime() > Date.now();
          },
          firstDayOfWeek: 1,
          shortcuts: []
        },
      manufacturers: psaData.manufacturers.map(manufacturer => manufacturer.name),
    };
  },
  created() {
    if(store.getters.psaRole == "0") {
      MessageBox.alert(
        "Zugriff verweigert.",
        {
          confirmButtonText: "OK",
          type: "error",
          callback: (action) => {
            router.push({ name: 'Overview' })
          },
        }
      );
    }
    moment.locale("de");
    this.loadPsaCategories();
    if(localStorage.SelectedPsaCategory) {
      this.psaCategory = localStorage.SelectedPsaCategory;
    }
    this.loadPsa();
    store.watch(
      (state) => state.userlocation,
      () => {
        this.location = store.getters.userlocation;
        this.loadPsa();
      }
    );
  },
  methods: {
    loadPsaCategories() {
      const psaCatRef = db.collection("psaCategories");
      psaCatRef.orderBy("Name").onSnapshot((snapshotChange) => {
        this.psaCategories = [];
        snapshotChange.forEach((doc) => {
          this.psaCategories.push({
            key: doc.id,
            psaCatName: doc.data().Name,
          });
        });
      });
    },
    loadPsa() {
      // get PSA data from firebase
      const psaRef = db.collection("psa");
      psaRef.where('Type', '==', this.psaCategory).where('locationID', '==', this.location).where('Status', '!=', "Removed").onSnapshot((snapshotChange) => {
        const psaPromises = [];
        snapshotChange.forEach((doc) => {
          var lastMaintenance = "";
          if(doc.data().LastMaintenance != null) {
            lastMaintenance = moment(new Date(doc.data().LastMaintenance.seconds * 1000)).format("MMM yyyy").toString();
          } else {
            lastMaintenance = moment(new Date('2000-01-01')).format("MMM yyyy").toString();
          }
          var nextMaintenance = "";
          if(doc.data().NextMaintenance != null) {
            nextMaintenance = moment(new Date(doc.data().NextMaintenance.seconds * 1000)).format("MMM yyyy").toString();
          } else {
            nextMaintenance = moment(new Date('2000-01-01')).format("MMM yyyy").toString();
          }
          var ProdDate = "";
          if(doc.data().ProdDate != null) {
            ProdDate = moment(new Date(doc.data().ProdDate.seconds * 1000)).format("MMM yyyy").toString();
          } else {
            ProdDate = moment(new Date('2000-01-01')).format("MMM yyyy").toString();
          }
          var FirstUse = "";
          if(doc.data().FirstUse != null) {
            FirstUse = moment(new Date(doc.data().FirstUse.seconds * 1000)).format("MMM yyyy").toString();
          } else {
            FirstUse = moment(new Date('2000-01-01')).format("MMM yyyy").toString();
          }
          var status = doc.data().Status;
          if (status == 'maintenance') {
            status = "maintenance";
          } else if (status != 'NOK' && moment().isSameOrAfter(moment(new Date(doc.data().NextMaintenance)))) {
            status = "maintenance";
          } else if (status != 'NOK' && moment().isBefore(moment(new Date(doc.data().NextMaintenance)))) {
            status = "OK";
          }

          // Check subcomponents in subcollection `components` for EOLDate reached (on or before today)
          const compRef = db.collection('psa').doc(doc.id).collection('components');
          const psaPromise = compRef.get().then((compSnap) => {
            let hasEOLReached = false;
            compSnap.forEach((cdoc) => {
              const cdata = cdoc.data();
              // Skip removed components if schema provides such flags
              if ((cdata && cdata.Status === 'Removed') || (cdata && cdata.Removed === true)) {
                return;
              }
              let eolDate = null;
              if (cdata && cdata.EOLDate) {
                if (cdata.EOLDate.seconds) {
                  eolDate = new Date(cdata.EOLDate.seconds * 1000);
                } else {
                  // Fallback: attempt to construct Date directly
                  eolDate = new Date(cdata.EOLDate);
                }
              }
              if (eolDate && moment().isSameOrAfter(moment(eolDate))) {
                hasEOLReached = true;
              }
            });
            // If any subcomponent reached EOL, set to maintenance unless already NOK
            if (hasEOLReached && status !== 'NOK') {
              status = 'maintenance';
            }
            return {
              key: doc.id,
              psaType: doc.data().Type,
              psaManufacturer: doc.data().Manufacturer,
              psaItem: doc.data().Item,
              psaSerialNumber: doc.data().SerialNumber,
              psaOwnId: doc.data().OwnId,
              psaProdDate: ProdDate,
              psaFirstUse: FirstUse,
              psaLastMaintenance: lastMaintenance,
              psaNextMaintenance: nextMaintenance,
              psaStatus: status,
            };
          }).catch(() => {
            // If components fetch fails, return the PSA without subcomponent-based override
            return {
              key: doc.id,
              psaType: doc.data().Type,
              psaManufacturer: doc.data().Manufacturer,
              psaItem: doc.data().Item,
              psaSerialNumber: doc.data().SerialNumber,
              psaOwnId: doc.data().OwnId,
              psaProdDate: ProdDate,
              psaFirstUse: FirstUse,
              psaLastMaintenance: lastMaintenance,
              psaNextMaintenance: nextMaintenance,
              psaStatus: status,
            };
          });
          psaPromises.push(psaPromise);
        });

        Promise.all(psaPromises).then((items) => {
          this.psa = items;
          this.counterOK = this.psa.filter(x => x.psaStatus == 'OK').length;
          this.counterNOK = this.psa.filter(x => x.psaStatus == 'NOK').length;
          this.counterMaintenance = this.psa.filter(x => x.psaStatus == 'maintenance').length;
          this.loading = false;
        });
      });
    },
    showDetails(row, column) {
      if (column.property) {
        router.push({ name: "PsaDetails", params: { psaId: row.key } });
      }
    },
    filterStatus(value, row) {
      return row.psaStatus === value;
    },
    updateLocation(loc) {
      this.location = loc
      this.loadPsa()
    },
    updatePsaCategory(cat) {
      localStorage.SelectedPsaCategory = this.psaCategory
      this.loadPsa()
    },
    newPsa() {
      this.showNewPsaModal = true;
      const psaTemplateRef = db.collection("psaTemplates");
      psaTemplateRef.orderBy("Name").onSnapshot((snapshotChange) => {
        this.psaTemplates = [];
        snapshotChange.forEach((doc) => {
          this.psaTemplates.push({
            key: doc.id,
            psaTemplateName: doc.data().Name,
            psaType: doc.data().Type,
            psaManufacturer: doc.data().Manufacturer,
            psaItem: doc.data().Item,
            psaGalLink: doc.data().GalLink,
            psaEOL: doc.data().EOL,
          });
        });
      });
    },
    templateSelected() {
      const selectedTemplate = this.psaTemplates.find(t => t.psaTemplateName == this.newPsaTemplate);
      if(selectedTemplate) {
        this.newPsaType = selectedTemplate.psaType;
        this.newPsaManufacturer = selectedTemplate.psaManufacturer;
        this.newPsaName = selectedTemplate.psaItem;
        this.newPsaGalLink = selectedTemplate.psaGalLink;
        this.newPsaEOL = selectedTemplate.psaEOL;
      } else {
        this.newPsaType = "";
        this.newPsaManufacturer = "";
        this.newPsaName = "";
        this.newPsaGalLink = "";
        this.newPsaEOL = 10;
      }
    },
    addPsa() {
      console.log(this.newPsaTemplate);
      const psaRef = db.collection("psa");
      psaRef.add({
        Type: this.newPsaType,
        Manufacturer: this.newPsaManufacturer,
        Item: this.newPsaName,
        GalLink: this.newPsaGalLink,
        SerialNumber: this.newPsaSerialNumer,
        OwnId: this.newPsaOwnId,
        ProdDate: new Date(this.newPsaProdDate),
        FirstUse: new Date(this.newPsaFirstUse),
        LastMaintenance: new Date(this.newPsaFirstUse),
        NextMaintenance: moment(this.newPsaFirstUse).add(1, "years").toDate(),
        EOL: this.newPsaEOL,
        Status: 'OK',
        locationID: this.location,
      }).then(() => {
        this.showNewPsaModal = false;
        this.newPsaTemplate = "";
        this.newPsaSerialNumer = "";
        this.newPsaOwnId = "";
        this.newPsaFirstUse = "";
        this.newPsaProdDate = "";
        this.$notify({
          message: "PSA wurde erfolgreich hinzugefügt!",
          icon: "fa fa-check-circle",
          horizontalAlign: "right",
          verticalAlign: "bottom",
          type: "success",
          showClose: true,
          timeout: 5000,
        });
        this.loadPsa();
      }).catch((error) => {
        this.$notify({
          message: "Fehler beim Hinzufügen der PSA: " + error,
          icon: "fa fa-exclamation-circle",
          horizontalAlign: "right",
          verticalAlign: "bottom",
          type: "danger",
          showClose: true,
          timeout: 5000,
        });
      });
    }
  },
};
</script>
<style>
.el-tag {
  color: white !important;
}
</style>